var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcIconMissionH8(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64 29.607c0 16.352-13.88 29.607-31 29.607-17.12 0-31-13.255-31-29.607C2 13.255 15.88 0 33 0c17.12 0 31 13.255 31 29.607",
    fill: "#E5F9F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 65c-8.75 0-16.943-3.298-23.074-9.287a1.341 1.341 0 0 1-.033-1.88 1.3 1.3 0 0 1 1.854-.034c5.638 5.51 13.186 8.544 21.253 8.544 8.045 0 15.578-3.02 21.213-8.504a1.3 1.3 0 0 1 1.854.038c.502.53.486 1.372-.038 1.88C49.904 61.718 41.725 65 33 65",
    fill: "#75D3C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.868 11.9c-7.705.843-3.934 5.284-3.934 5.284-1.132.919.156 3.675.156 3.675 2.418 2.526 5.893 2.143 5.893 2.143l.715 1.29c1.237 6.816-2.755 11.802-2.755 11.802-4.759-4.593-12.01-1.148-12.01-1.148-1.587-5.283-12.238-5.513-12.238-5.513l-6.662-1.107c-.018.426-.033.852-.033 1.281 0 9.74 4.925 18.38 12.526 23.775 5.2-1.073 8.118-3.178 8.118-3.178.301 1.15 5.142 2.607 5.142 2.607 14.588 2.957 17.923-3.93 17.923-3.93 2.493-3.064 1.284-19.218 1.284-19.218C43.745 9.68 32.868 11.9 32.868 11.9",
    fill: "#75D3C7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m14.8 27.865-1.754-8.144 3.496-.773 1.754 8.144zM24.16 28.26l-3.44-.991 2.246-7.995 3.44.992z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcIconMissionH8);
export default __webpack_public_path__ + "static/media/ic-icon-mission-h-8.1ade43b99fba52740af8ca2dc81e0c01.svg";
export { ForwardRef as ReactComponent };